import { formatToFixedNumber } from '@/root/shared-helpers'

interface GetFormattedPercentProps {
  amount: number
  totalRefundAmount: number
  feeAmount: number
}

export const getFormattedPercent = ({ amount, totalRefundAmount, feeAmount }: GetFormattedPercentProps) => {
  const percent = amount > 0 ? (totalRefundAmount * 100) / (amount - feeAmount) : 0
  return `${formatToFixedNumber({ value: percent })}%`
}
